import * as _ from "lodash";
import { UsersRepo } from "./users.repo";
import { UserItem } from "./UserItem";

class userListController implements angular.IOnInit {
  public users: UserItem[] = [];
  public clients: UserItem[] = [];
  public filteredUsers: Array<UserItem> = [];
  public filteredClients: Array<UserItem> = [];
  public searchText: string;
  public statusFilter: string = "";
  public statusFilterClients: string = "";
  public statusOptions: Array<string> = [
    "All",
    "Active",
    "Disabled",
    "Awaiting Confirmation",
    "Unknown",
  ];

  /** @ngInject */
  constructor(
    private usersRepo: UsersRepo,
    private $state: angular.ui.IStateService,
    private notifyjs: any
  ) {}

  $onInit() {
    this.populateUserData();
  }

  populateUserData() {
    this.users = [];
    this.usersRepo
      .getUsers()
      .then((users) => {
        this.users = users.filter(
          (u) => !u.isClient && u.name !== null && u.email !== null
        );
        this.clients = users.filter(
          (u) => u.isClient && u.name !== null && u.email !== null
        );
        this.filteredUsers = this.sortUsersByStatus([...this.users]);
        this.filteredClients = this.sortUsersByStatus([...this.clients]);
      })
      .catch((err) => this.notifyjs(`Failed to retrieve users: ${err}`));
  }

  viewUserDetails(user: UserItem) {
    this.$state.go("root.users.details", { id: user.id });
  }

  createNewUser() {
    this.$state.go("root.users.create");
  }

  getUserStatus(user) {
    if (!user.isActive) return "Disabled";
    else {
      switch (user.status) {
        case "CONFIRMED": {
          return "Active";
        }
        case "FORCE_CHANGE_PASSWORD": {
          return "Awaiting Confirmation";
        }
        default: {
          return "Unknown";
        }
      }
    }
  }

  resendInvite(event: angular.IAngularEvent, user: UserItem) {
    event.stopPropagation();

    this.usersRepo
      .resendInvite(user.id)
      .then(() => this.notifyjs("Invitation has been resent", "info"));
  }

  sortUsersByStatus(userItems: Array<UserItem>) {

    let filteredUserItems = userItems.filter( (user) => user.status != null);
    return filteredUserItems.sort((a, b) => {
      const nameA = a.name || "";
      const nameB = b.name || "";

      if (a.status === "Active" && b.status !== "Active") {
        return -1;
      } else if (a.status !== "Active" && b.status === "Active") {
        return 1;
      }

      if (a.status === b.status) {
        return nameA.localeCompare(nameB);
      } else {
        return a.status.localeCompare(b.status);
      }
    });
  }

  filterColumn(filter: string) {
    try {
      if (
        this.statusFilter === "All" ||
        this.statusFilter === "" ||
        this.statusFilter === null ||
        this.statusFilter === undefined
      ) {
        this.filteredUsers = this.sortUsersByStatus([...this.users]);
        return;
      }

      this.filteredUsers = this.sortUsersByStatus([
        ...this.users.filter((user) => this.getUserStatus(user) === filter),
      ]);
    } catch (error) {
      this.filteredUsers = this.sortUsersByStatus([...this.users]);
    }
  }

  filterClientsColumn(filter: string) {
    try {
      if (
        this.statusFilterClients === "All" ||
        this.statusFilterClients === "" ||
        this.statusFilterClients === null ||
        this.statusFilterClients === undefined
      ) {
        this.filteredClients = this.sortUsersByStatus([...this.clients]);
        return;
      }

      this.filteredClients = this.sortUsersByStatus([
        ...this.clients.filter(
          (client) => this.getUserStatus(client) === filter
        ),
      ]);
    } catch (error) {
      this.filteredClients = this.sortUsersByStatus([...this.clients]);
    }
  }
}

export const userList: angular.IComponentOptions = {
  template: require("./userList.html"),
  controller: userListController,
};



// WEBPACK FOOTER //
// ./src/app/users/userList.ts